/* Glimmer — página do produto: "Adicionar ao carrinho" sem sair da página.
   Adiciona pela /cart/add.js, atualiza o número da sacola e mostra o aviso "Produto adicionado ao carrinho"
   com "Ver sacola" e "Continuar comprando". A trava de forma de pagamento (glimmer-carrinho-forma.js) roda
   antes, na fase de captura: se ela bloquear, este script nem é chamado. */
(function () {
  // Relevância do catálogo: conta 1 visualização desta página de produto (1x por produto por sessão).
  try {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    var chave = m && ('glimmer_vista_' + m[1]);
    if (m && !sessionStorage.getItem(chave)) {
      sessionStorage.setItem(chave, '1');
      fetch('https://glimmer-checkout.vercel.app/api/relevancia', { method: 'POST', keepalive: true, headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify({ handle: decodeURIComponent(m[1]) }) }).catch(function () {});
    }
  } catch (e) {}

  var form = document.querySelector('form.product-form[action*="/cart/add"], .product-form form[action*="/cart/add"], form[action*="/cart/add"]');
  if (!form) { return; }

  var aviso = null;
  var timer = null;
  function dinheiro(c) { return (c / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function estilos() {
    if (document.getElementById('glimmer-adicionar-css')) { return; }
    var st = document.createElement('style');
    st.id = 'glimmer-adicionar-css';
    st.textContent =
      '.glimmer-add{position:fixed;z-index:1200;left:50%;top:calc(env(safe-area-inset-top) + 10px);bottom:auto;transform:translate(-50%,-20px);width:min(420px,calc(100% - 24px));opacity:0;pointer-events:none;transition:opacity .2s,transform .2s}' +
      '.glimmer-add.is-aberto{opacity:1;transform:translate(-50%,0);pointer-events:auto}' +
      '@media(min-width:1000px){.glimmer-add{left:auto;right:24px;top:96px;bottom:auto;transform:translate(0,-12px)}.glimmer-add.is-aberto{transform:translate(0,0)}}' +
      '.glimmer-add__caixa{background:#fff;border:1px solid #EFE6E3;border-radius:16px;box-shadow:0 12px 40px rgba(42,26,29,.18);padding:14px;font-family:inherit;color:#2A1A1D}' +
      '.glimmer-add__topo{display:flex;align-items:center;gap:8px;margin:0 0 10px;font-size:14px;font-weight:700;color:#137A43}' +
      '.glimmer-add__topo svg{width:18px;height:18px;flex:none}' +
      '.glimmer-add__fechar{margin-left:auto;border:0;background:none;font-size:22px;line-height:1;color:#7A6A6D;cursor:pointer;padding:0 4px}' +
      '.glimmer-add__item{display:flex;gap:12px;align-items:center;margin:0 0 12px}' +
      '.glimmer-add__item img{width:56px;height:56px;object-fit:contain;border-radius:10px;background:#FAF6F4;flex:none}' +
      '.glimmer-add__nome{font-size:13.5px;font-weight:600;line-height:1.3;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}' +
      '.glimmer-add__info{font-size:12px;color:#7A6A6D;margin-top:2px}' +
      '.glimmer-add__botoes{display:flex;gap:8px}' +
      '.glimmer-add__botoes a,.glimmer-add__botoes button{flex:1;display:inline-flex;align-items:center;justify-content:center;height:44px;border-radius:999px;font:inherit;font-size:14px;font-weight:700;text-decoration:none;cursor:pointer}' +
      '.glimmer-add__ver{background:#781430;color:#fff;border:1px solid #781430}' +
      '.glimmer-add__ver:hover{background:#5E0F25;color:#fff}' +
      '.glimmer-add__seguir{background:#fff;color:#781430;border:1px solid #781430}';
    document.head.appendChild(st);
  }

  function fechar() {
    if (aviso) { aviso.classList.remove('is-aberto'); }
    clearTimeout(timer);
  }

  function mostrar(item, qtdCarrinho) {
    estilos();
    if (!aviso) {
      aviso = document.createElement('div');
      aviso.className = 'glimmer-add';
      aviso.setAttribute('role', 'status');
      aviso.setAttribute('aria-live', 'polite');
      document.body.appendChild(aviso);
      aviso.addEventListener('click', function (e) {
        if (e.target.closest('[data-add-fechar], [data-add-seguir]')) { fechar(); }
      });
      aviso.addEventListener('mouseenter', function () { clearTimeout(timer); });
      aviso.addEventListener('mouseleave', function () { timer = setTimeout(fechar, 3000); });
    }
    var img = item && (item.featured_image && item.featured_image.url || item.image);
    var variante = item && item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    var pagamento = item && item.properties && item.properties['Pagamento'];
    aviso.innerHTML = '<div class="glimmer-add__caixa">' +
      '<p class="glimmer-add__topo"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="m8 12.5 2.8 2.8L16.5 9.5"/></svg>' +
      'Produto adicionado ao carrinho<button type="button" class="glimmer-add__fechar" data-add-fechar aria-label="Fechar">&times;</button></p>' +
      (item ? '<div class="glimmer-add__item">' + (img ? '<img src="' + esc(img) + '" alt="">' : '') +
        '<div><div class="glimmer-add__nome">' + esc(item.product_title || item.title) + '</div>' +
        '<div class="glimmer-add__info">' + [variante, 'Qtd: ' + item.quantity, pagamento ? 'Pagamento: ' + pagamento : ''].filter(Boolean).map(esc).join(' · ') + '</div></div></div>' : '') +
      '<div class="glimmer-add__botoes"><a class="glimmer-add__ver" href="/cart">Ver sacola' + (qtdCarrinho ? ' (' + qtdCarrinho + ')' : '') + '</a>' +
      '<button type="button" class="glimmer-add__seguir" data-add-seguir>Continuar comprando</button></div></div>';
    requestAnimationFrame(function () { aviso.classList.add('is-aberto'); });
    clearTimeout(timer);
    timer = setTimeout(fechar, 6000);
  }

  function atualizarContador(n) {
    document.querySelectorAll('.header__cart-count, [data-glimmer-tab-qtd]').forEach(function (el) { el.textContent = n; if (el.hasAttribute('data-glimmer-tab-qtd')) { el.hidden = !n; } });
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) { return; }
    e.preventDefault();
    var botoes = f.querySelectorAll('[type="submit"], [data-action="add-to-cart"]');
    botoes.forEach(function (b) { b.disabled = true; b.classList.add('is-carregando'); });
    var dados = new FormData(f);
    fetch('/cart/add.js', { method: 'POST', body: dados, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) { throw new Error((res.d && (res.d.description || res.d.message)) || 'Não foi possível adicionar.'); }
        var item = res.d && res.d.items ? res.d.items[0] : res.d;
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
          atualizarContador(c.item_count);
          mostrar(item, c.item_count);
          // Avisa os outros scripts (ex.: trava da forma de pagamento) que o carrinho mudou.
          document.dispatchEvent(new CustomEvent('product:added', { bubbles: false, detail: { quantity: item && item.quantity || 1 } }));
        });
      })
      .catch(function (err) { alert(err.message || 'Não foi possível adicionar ao carrinho.'); })
      .then(function () { botoes.forEach(function (b) { b.disabled = false; b.classList.remove('is-carregando'); }); });
  });
})();
